import { WsButtonDismissAction } from "../ChatAction";

export default function dismissWsButton(id: string): WsButtonDismissAction {
    return {
        type: "ws_button_dismiss",
        detail: {
            id,
            timestamp: +new Date()
        }
    };
}
